import { searchTenantUsers } from '@infuse/api/iam/tenant';
import { useGenericUsers } from '@infuse/iam/user/queries';

export const useTenantUsers = () =>
  useGenericUsers({
    apiFn: searchTenantUsers,
    queryKeys: ['users', 'tenant'],
    onlyEnableWithParentId: true
  });
